<div class="view-notes-container">
    @if (!inPresentationMode && (!isGlobal || !isGlobalEditPartial)) {
        <ddv-edit-dashboard-note
            [note]="dashboardNote"
            (saveNote)="onSaveDashboardNote($event)"
            (deleteNote)="onDeleteDashboardNote()"
        >
        </ddv-edit-dashboard-note>
    } @else if (dashboardNote) {
        <ddv-view-dashboard-note [note]="dashboardNote"></ddv-view-dashboard-note>
    }
</div>

<app-filters-bar
    [dashboardId]="dashboardId"
    [inPresentationMode]="inPresentationMode"
    [fuzzyDates]="fuzzyDates"
    [ccFuzzyDates]="ccFuzzyDates"
    [funds]="funds"
    [userPreferences]="userPreferences"
    [clients]="clients"
    (filtersRemoved)="filtersRemoved.emit($event)"
>
</app-filters-bar>
